const { Component } = require('react')
const PropTypes = require('prop-types')
const MobileOption = require('app/components/products/configuration-mobile/MobileOption')

class ColorSelector extends Component {
  static get propTypes () {
    return {
      title: PropTypes.string,
      options: PropTypes.any.isRequired,
      onChange: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      title: translate('Farvenuance')
    }
  }

  constructor (props) {
    super(props)

    this.state = {
      colorTitle: this.firstColorTitle,
      value: this.firstColorValue,
      optionsOpen: false
    }
  }

  get value() {
    return this.state.value;
  }

  get defaultValue () {
    return this.props.options.length > 0 ? this.props.options[0] : ''
  }

  get firstColorValue () {
    const objArr = Object.keys(this.props.options)

    return objArr[0];
  }

  get firstColorTitle () {
    const objArr = Object.keys(this.props.options)
    return objArr.length > 0 ? this.props.options[objArr[0]] : null
  }

  get editIcon () {
    return (
      <svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'>
        <g transform='translate(-1160.001 -187)'>
          <path d='M618,184.874V189h-7.5v-7.5h4.125l1.5-1.5h-6A1.128,1.128,0,0,0,609,181.124v8.25a1.128,1.128,0,0,0,1.125,1.125h8.25a1.128,1.128,0,0,0,1.125-1.125v-6Z' transform='translate(551.001 8.501)' fill='#444' />
          <path d='M620.125,178,613,185.124V187h1.875L622,179.874A1.771,1.771,0,0,0,620.125,178Z' transform='translate(550.001 9.001)' fill='#444' />
        </g>
      </svg>
    )
  }

  reset () {
    this.selectElement.value = this.props.options[0]
  }

  _onChange = () => {
		this.setState({ colorTitle: this.props.options[this.value] })

    if (typeof this.props.onChange === "function") {
      return this.props.onChange(this.value);
    }
  }

  handleOnClick (e) {
    const val = e.target.value;
    this.setState({
      colorTitle: this.props.options[val],
      value: val
    })

    if (typeof this.props.onChange === "function") {
      return this.props.onChange(val);
    }
  }

  renderOptions () {
    const colors = []
    for (const key in this.props.options) {
      const colorObj = this.props.options[key]
      colors.push(<option key={colorObj} value={key}>{colorObj}</option>)
    }
    return colors
  }

  openOptions () {
    this.setState({ optionsOpen: true })
    this.props.editOptions()
  }

  closeOptions () {
    this.setState({ optionsOpen: false })
    this.props.saveOptions()
  }

  renderOptionsNew () {
    const optionsArray = Object.keys(this.props.options)
    return optionsArray.map((option, key) =>
      <MobileOption key={option} value={option} name='color-selector' text={this.props.options[option]} defaultChecked={key === 0} onClick={e => this.handleOnClick(e)} />)
  }

  render () {
    return (
      <div className='color-selector'>
        <div className='product-configurator-info'>
          <div className='product-configurator-info__row'>
            <div className='product-configurator-info__text'>
              {this.props.title}
            </div>
            <div className='product-configurator-info__title product-configurator-info__title--flex cursor-pointer' onClick={() => this.openOptions()}>
              {this.editIcon}
              <span>
                {this.state.colorTitle}
              </span>
            </div>
          </div>
        </div>
        <div className='product-configurator-options' style={this.state.optionsOpen ? { display: 'block' } : null}>
          <div className="product-configurator-title">
            Vælg farve nuance
          </div>
          <div className="product-configurator-scrollable">
            <div className="mobile-options">
              {this.renderOptionsNew()}
            </div>
          </div>
          <button className='btn primary' onClick={() => this.closeOptions()}>Gem</button>
        </div>
      </div>
    )
  }
}

module.exports = ColorSelector
